import React from 'react';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import { IOrderProduct } from '../../types/orderProduct';
import { AppState } from '../../redux';
import { removeProductAction } from '../../redux/actions';
import { calcOrderProductsSubtotal } from '../../helpers/utils';
import { OrderSummary } from '../../components/OrderSummary';
import { getAuthenticationState, getCartState } from '../../redux/selectors';
import { IUser } from '../../types';
import { ShopMode } from '../../redux/types';

const useStyles = makeStyles((theme) => ({
  infoBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

interface CartProps {
  user: IUser | null;
  items: IOrderProduct[];
  removeProductAction: typeof removeProductAction;
}

const Cart: React.FC<CartProps> = ({ user, items, removeProductAction }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const handleRemoveProduct = (productOrderId: number) => {
    removeProductAction(productOrderId);
    enqueueSnackbar('Prodotto rimosso dal carrello.', { variant: 'info' });
  };

  const { subTotal } = calcOrderProductsSubtotal(items, !user?.partner, undefined, ShopMode.LocalDelivery);
  const minOrder = user?.partner?.minOrder ?? 20;

  const orderValid = items.some((item) => item.buyableAlone) || subTotal >= minOrder;

  return (
    <Container>
      <Typography variant="h3" gutterBottom color="primary">
        Riepilogo ordine
      </Typography>
      <Typography variant="body1" gutterBottom>
        Controlla i prodotti che hai aggiunto al tuo carrello. Se vuoi aggiungere altri prodotti premi il bottone "Torna
        alla lista", se vuoi eliminare dei prodotti utilizza il bottone con il cestino. Dopo che cliccherai "Conferma"
        ti verra chiesto l'indirizzo di consegna.
      </Typography>
      <OrderSummary
        orderProducts={items}
        isUserLogged={!!user}
        partner={user?.partner}
        editable
        removeProductAction={handleRemoveProduct}
        shopMode={ShopMode.LocalDelivery}
      />
      <Box className={classes.infoBox}>
        {!orderValid && <Typography variant="body2">Ordine minimo {minOrder}€</Typography>}
      </Box>
      <Box className={classes.buttonBox}>
        {user ? (
          <>
            <Button variant="outlined" component={RouterLink} to="/ordina" color="primary">
              Torna alla lista
            </Button>
            <Button
              variant="contained"
              component={RouterLink}
              to="/checkout"
              color="primary"
              disabled={items.length === 0 || !orderValid}
            >
              Conferma ordine
            </Button>
          </>
        ) : (
          <Button variant="contained" component={RouterLink} to="/signin" color="primary">
            Login
          </Button>
        )}
      </Box>
    </Container>
  );
};

const mapStateToProps = (state: AppState) => ({
  user: getAuthenticationState(state).user,
  items: getCartState(state).items,
});
export default connect(mapStateToProps, { removeProductAction })(Cart);
